import { isAuthExpiredError } from '@utils/isAuthExpiredError.js'

const BASE_MSTOCK_QUERY_OPTIONS = {
  throwOnError: isAuthExpiredError,
  retry: false,
  gcTime: Infinity,
  refetchOnMount: 'always'
}

export const MSTOCK_QUERY_OPTIONS = {
  ...BASE_MSTOCK_QUERY_OPTIONS,
  refetchOnWindowFocus: false
}

export const MSTOCK_FOCUS_QUERY_OPTIONS = {
  ...BASE_MSTOCK_QUERY_OPTIONS,
  refetchOnWindowFocus: 'always'
}
